<style lang="less" scoped>
  .status {
    display: inline-block;
    vertical-align: middle;
    color: #9ba7b5;
  }
  .v-icon {
    display: inline-block;
    margin-top: -4px;
    font-size: 16px;
  }
</style>

<template>
  <v-menu
    v-if="has_status"
    bottom
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        class="status"
        v-on="on"
      >
        <span v-if="status.rtt">
          <span v-if="status.downlink > 5 || status.rtt <= 400">
            连接状态佳
            <v-icon color="green">mdi-signal-cellular-3</v-icon>
          </span>
          <span v-else-if="status.downlink >= 1">
            连接状态一般
            <v-icon color="warning">mdi-signal-cellular-2</v-icon>
          </span>
          <span v-else>
            连接状态差
            <v-icon color="red">mdi-signal-cellular-1</v-icon>
          </span>
        </span>
        <span
          v-else
          class="new-element-effect"
        >
          连接断开
          <v-icon
            color="red"
          >mdi-network-off-outline</v-icon>
        </span>
      </div>
    </template>
    <v-card>
      <v-card-text>
        <div>
          带宽:
          <span v-if="status.downlink >= 10">10+</span>
          <span v-else>{{ status.downlink }}</span>
          Mb/s
        </div>
        <div>时延: {{ status.rtt }} ms</div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    data() {
      return {
        // downlink 带宽
        // effectiveType 网络类型
        // rtt 时延
        status: {}
      }
    },
    computed: {
      has_status() {
        // eslint-disable-next-line no-prototype-builtins
        return this.status.hasOwnProperty('rtt');
      }
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        const connection = window.navigator.connection;
        if (connection) {
          this.updateStatus(connection);
          connection.onchange = (ev) => {
            this.updateStatus(ev.currentTarget);
          }
        }
      },
      updateStatus(connection) {
        const status = {
          downlink: connection.downlink,
          effectiveType: connection.effectiveType,
          rtt: connection.rtt
        };
        this.$set(this, 'status', status);
      }
    }
  }
</script>
